import ProfileSetting from '@/Component/Profile/ProfileSetting'
import PasswordAndSecurity from '@/Component/Profile/ProfileSetting/PasswordAndSecurity'

const PasswordSecurityPage = () => {
    return (
        <ProfileSetting activeTab="password">
            <PasswordAndSecurity />
        </ProfileSetting>
    )
}

export default PasswordSecurityPage
